<nav class="navbar navbar-expand-lg navbar-light text-white position-absolute w-100">
  <div class="container border-bottom px-0 py-lg-2 py-0">
    <a class="navbar-brand ms-3 ms-lg-0" [routerLink]="['/','tours']">
        <img src="/assets/images/logo/logo.png" class="nav-logo" alt="">
    </a>    
    <div class="justify-content-between px-3 px-lg-0 menu-login d-flex" id="navbarContent" >
        <span class="navbar-text text-white pb-lg-0 pb-4 d-none d-lg-flex">
            Descrubrí los colores de tu destino
        </span>
      <ul class="navbar-nav ml-auto mb-2 mb-lg-0 pt-3 pt-lg-0 flex-row">
        <li class="nav-item" >
            <a class="text-white border-2 me-3 nav-link btn-md" [routerLink]="['/','tours','dashboard']"><!--<img src="assets/images/body/icons/search.svg" alt="">-->
              Ver Tours / Viajes</a>
        </li>       
        <li class="nav-item" ngbDropdown display="dynamic" placement="bottom-right">
            <a class="nav-link text-white"  tabindex="0" ngbDropdownToggle id="navbarDropdown1" role="button">
                <img src="assets/images/body/icons/user.svg" alt="">
            </a>
            <div ngbDropdownMenu aria-labelledby="navbarDropdown1" class="dropdown-menu animate" style="background-color: #00008b;">
              <a style="cursor: pointer;"  ngbDropdownItem class="dropdown-item text-white" [routerLink]="['/','user']" href="">Mi perfil</a>
              <a style="cursor: pointer;"  ngbDropdownItem class="dropdown-item text-white" (click)="logout()">Cerrar sesión</a>              
            </div>           
          </li>
      </ul>
    </div>
  </div>
</nav>
<!--<nav class="navbar navbar-expand-lg navbar-light text-white position-absolute w-100">

    <div class="container border-bottom px-0 py-lg-2 py-0">
      <a class="navbar-brand ms-3 ms-lg-0" href="">
          <img src="assets/images/logo/logo.png" class="nav-logo" alt="">
      </a>
      <button class="navbar-toggler me-3 me-lg-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-between px-3 px-lg-0" id="navbarText">
          <span class="navbar-text text-white pb-lg-0 pb-4 d-none d-md-block">
              Descrubrí los colores de tu destino
          </span>
        <ul class="navbar-nav mb-2 mb-lg-0 pt-3 pt-lg-0 flex-row justify-content-center">
          <li class="nav-item">
              <a href="tours" class="text-white rounded-pill border border-2 me-3 border-light nav-link btn-md btn-outline">Tours/Viajes</a>
          </li>
          <li class="nav-item">
              <a href="user" class="text-white rounded-pill border border-2 me-3 border-light nav-link btn-md btn-outline">Mi perfil</a>
          </li>
          <li class="nav-item">
            <a href="" (click)="logout()" class="text-white rounded-pill border border-2 border-light nav-link btn-md btn-outline">Cerrar sesión</a>
        </li>
        </ul>
      </div>
    </div>
  </nav>-->
